/**
 * Extrae un JWT limpio del query param `token`.
 * Algunos clientes de correo corrompen el enlace y anidan la URL dentro del token.
 */
export function extractAuthToken(raw: string | null | undefined): string | null {
  if (!raw) return null;

  let value = raw.trim();
  try {
    value = decodeURIComponent(value);
  } catch {
    // ya decodificado
  }

  const jwtMatch = value.match(
    /eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/
  );
  if (jwtMatch) {
    return jwtMatch[0];
  }

  const nested = value.match(/[?&]token=([^&]+)/i);
  if (nested?.[1]) {
    return extractAuthToken(nested[1]);
  }

  return value || null;
}
